import dateService from "../../../../../../../../common/utils/date/date.service";
import orderTranslationsHelper from "../../../../../../../../languages/order-translations.helper";

const getNewPlannedDateLabel = (newPlannedDate: Date | null) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .changeTime.newDateTemplateText;

  const formattedDate = newPlannedDate
    ? dateService.formatDateTime(newPlannedDate)
    : `-----`;

  return translations.replace("#{plannedDateString}", formattedDate);
};

const getNewPlannedDateTitle = (newPlannedDate: Date | null) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .changeTime.newDateTemplateText;

  const formattedDate = newPlannedDate
    ? dateService.formatDateTime(newPlannedDate)
    : `-----`;

  return translations.replace("#{plannedDateString}", formattedDate);
};

const orderDetailsHistoryEntryChangeRideContentChangeTimeHelper = {
  getNewPlannedDateLabel,
  getNewPlannedDateTitle,
};

export default orderDetailsHistoryEntryChangeRideContentChangeTimeHelper;
